/* eslint-disable react/no-children-prop */
import React, { FC } from 'react';
import { Container, Grid, Typography } from '@mui/material';
import useStyles from '../../assets/styles/components/titlePage';

type Props = {
  Icon?: FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  titleSecondary?: string;
  titleColor?: string;
  backgroundColor?: string;
  margin?: string;
  borderRadius?: string;
  textTransform?: string;
  fontSize?: string;
  paddingContent?: string;
};

const TitlePage: FC<Props> = ({
  Icon,
  title,
  titleSecondary = '',
  titleColor = '#444',
  backgroundColor = '#FCD3D3',
  borderRadius = '10px',
  margin = '5px 10px',
  textTransform = 'uppercase',
  fontSize = '0.8rem',
  paddingContent = '5px 8px',
}) => {
  const classeStyle = useStyles({
    backgroundColor,
    borderRadius,
    margin,
    titleColor,
    textTransform,
    fontSize,
    paddingContent,
  });

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Grid className={classeStyle.gridContent}>
        {Icon && <Icon className={classeStyle.icon} />}
        <Grid className={classeStyle.gridContentText}>
          {title && (
            <Typography className={classeStyle.title}>{title}</Typography>
          )}
          {titleSecondary && (
            <Typography className={classeStyle.titleSecondary}>
              {titleSecondary}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default TitlePage;
